/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import Loader from "../../../components/Loader/Index";
import GeoMapLeaflet from "../../../components/_utils/GeoMapLeaflet";

import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SearchBar from "../../../components/_utils/CommonSearchComponents/SearchBar";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../utils/configurationProvider";
import TEXT from "../../../../src/utils/globalText";
import CommonContainerCard from "../../../components/_utils/CommonContainerCard";
import TopNavSmallButton from "../../../components/_utils/CommonButtons/TopNavSmallButton";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs";
import CommonDetailCard from "../../../components/_utils/CommonDetailCard";
import PrimaryButton from "../../../components/_utils/CommonButtons/PrimaryButton";
import CommonToast from "../../../components/_utils/CommonToast";
import Validation from "../../../utils/validation";
import { toast } from "react-toastify";
import accountNameStandardised from "../../../utils/accountNamestandardised";
import useServiceChecker from "../../../components/ServiceChecker";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import DINVerification from "../DINVerification";
import ICONS from "../../../assets/Icons";
import {
  getCINDetails,
  resetSelectedCin,
  resetGetCinData,
  verifyCIN,
} from "../../../redux/features/sharedResources/sharedResources";
import useRestrictedAction from "../../../hooks/useRestrictedAction";

const CINVerification = ({ cin_no, popup }) => {
  const services = useSelector((state) => state.refreshToken.services);
  const inputRef = useRef("");
  const {
    cinDetailsData,
    cinDetailsError,
    getVerifyCinLoading,
    cinVerificationData,
    cinVerificationLoading,
    selectedCinData,
  } = useSelector((state) => state.sharedResources);

  const navigate = useNavigate();
  const location = useLocation();
  const [ensureAny] = useServiceChecker();
  const [activeButton, setActiveButton] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();
  const [cinNo, setCinNo] = useState("");
  const [prevCinNo, setPrevCinNo] = useState("");
  const [tabIndex, setTabIndex] = useState(
    activeButton === GlobalConfiguration?.lengthCheckZero
      ? GlobalConfiguration?.lengthCheckZero
      : activeButton === GlobalConfiguration?.lengthCheckOne
        ? GlobalConfiguration?.lengthCheckOne
        : activeButton === GlobalConfiguration?.lengthCheckTwo
          ? GlobalConfiguration?.lengthCheckTwo
          : GlobalConfiguration?.lengthCheckZero,
  );

  const cinNumber = location.state?.cinNumber;
  const initialCinFromLocation = useRef(
    location.state?.cinNumber?.toUpperCase() || "",
  );

  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");
  const [cinStatus, setCinStatus] = useState(null);

  const [dinNo, setDinNo] = useState("");
  const [showDINPopup, setDINShowPopup] = useState(false);

  const handleCin = (e) => {
    const value = e.target ? e.target.value : e;

    if (!value.length) {
      setActiveButton(GlobalConfiguration?.lengthCheckZero);
      setTabIndex(GlobalConfiguration?.lengthCheckZero);
      setPrevIndex(GlobalConfiguration?.lengthCheckZero);
    }
    if (value.length > GlobalConfiguration.cinLength) {
      return;
    }
    if (!Validation.alphanumericRegex.test(value)) {
      return;
    }
    setCinNo(value.toUpperCase());
    setPrevCinNo("");
    setCinStatus(null);
  };

  const validateCinNo = (cin) => {
    if (
      !Validation.cinRegex.test(cin) ||
      cin.length !== GlobalConfiguration.cinLength
    ) {
      setCinStatus("error");
      // dispatch(resetGetCinError());
      toast.dismiss();
      CommonToast({
        text: "Invalid CIN!",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
      return false;
    }
    setCinStatus("success");
    return true;
  };

  const handleCinClick = async (showToast = false) => {
    setTabIndex(GlobalConfiguration?.lengthCheckZero);
    setActiveButton(GlobalConfiguration?.lengthCheckZero);
    if (!validateCinNo(cinNo)) return;

    setPrevCinNo(cinNo);
    if (!showToast) {
      await dispatch(getCINDetails({ search_string: cinNo }));
    }
    if (showToast) {
      toast.dismiss();
      CommonToast({
        text: "Updating details.",
        icon: ICONS?.LOADER_GIF,
        variant: "var(--processing)",
        buttonNeeded: false,
        btnProps: {
          enabledBgColor: "var(--primary-bg)",
          enabledTextColor: "var(--text-primary)",
          btnType: "button",
          isDisabled: false,
          hoverOption: "white",
        },
      });
      const response = await dispatch(
        verifyCIN({ search_string: cinNo, showToast }),
      );

      if (response?.payload?.status === true) {
        toast.dismiss();
        CommonToast({
          text: "Details updated successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        toast.dismiss();
        CommonToast({
          text: "Failed to update.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }
    }
    setActiveButton(GlobalConfiguration?.lengthCheckZero);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !isCinButtonDisabled) {
      handleCinClick();
    }
  };

  const formatDate = (GSTDate) => {
    let dateObj = new Date(GSTDate);

    let day = dateObj.getDate();
    let year = dateObj.getFullYear();
    let month = dateObj.toLocaleString("default", { month: "short" });
    let formattedDate = `${day} ${month}, ${year}`;

    if (formattedDate === null || formattedDate === undefined) {
      return "NA";
    } else {
      return formattedDate;
    }
  };

  const formatAmount = (amount) => {
    if (!amount) return "0";
    return new Intl.NumberFormat("en-IN").format(amount);
  };

  const tabOptions = [
    {
      label: "Details",
      key: "details",
      handler: () => setActiveButton(GlobalConfiguration?.lengthCheckZero),
    },
    {
      label: "Directors",
      key: "directors",
      handler: () => setActiveButton(GlobalConfiguration?.lengthCheckOne),
    },
    {
      label: "Address",
      key: "address",
      handler: () => setActiveButton(GlobalConfiguration?.lengthCheckTwo),
    },
  ];

  const contactDetailsEntries = [
    {
      heading: "Contact number",
      content: (() => {
        const phoneNumber =
          cinVerificationData?.cin_details?.cin_number ===
          cinDetailsData?.cin_details?.cin_number
            ? cinVerificationData?.cin_details?.phone_number ||
              cinDetailsData?.cin_details?.phone_number
            : cinDetailsData?.cin_details?.phone_number;
        return phoneNumber || "N/A";
      })(),
      type: "text",
    },
    {
      heading: "Email ID",
      content: (() => {
        const emailId =
          cinVerificationData?.cin_details?.cin_number ===
          cinDetailsData?.cin_details?.cin_number
            ? cinVerificationData?.cin_details?.email ||
              cinDetailsData?.cin_details?.email
            : cinDetailsData?.cin_details?.email;
        return emailId || "N/A";
      })(),
      type: "text",
    },
  ];

  const capitalDetailsEntries = [
    {
      heading: "Paid up capital",
      content: (() => {
        const paidUpCapital =
          cinVerificationData?.cin_details?.cin_number ===
          cinDetailsData?.cin_details?.cin_number
            ? cinVerificationData?.cin_details?.paid_up_capital ||
              cinDetailsData?.cin_details?.paid_up_capital
            : cinDetailsData?.cin_details?.paid_up_capital;

        return `INR ${formatAmount(paidUpCapital || GlobalConfiguration?.lengthCheckZero)}`;
      })(),
      type: "text",
    },
    {
      heading: "Authorized capital",
      content: (() => {
        const authorizedCapital =
          cinVerificationData?.cin_details?.cin_number ===
          cinDetailsData?.cin_details?.cin_number
            ? cinVerificationData?.cin_details?.authorized_capital ||
              cinDetailsData?.cin_details?.authorized_capital
            : cinDetailsData?.cin_details?.authorized_capital;

        return `INR ${formatAmount(authorizedCapital || GlobalConfiguration?.lengthCheckZero)}`;
      })(),
      type: "text",
    },
  ];

  const complianceDetailsEntries = [
    {
      heading: "Last AGM date",
      content: (() => {
        const agmDate =
          cinVerificationData?.cin_details?.cin_number ===
          cinDetailsData?.cin_details?.cin_number
            ? cinVerificationData?.cin_details?.last_agm_date ||
              cinDetailsData?.cin_details?.last_agm_date
            : cinDetailsData?.cin_details?.last_agm_date;
        return agmDate ? formatDate(agmDate) : "N/A";
      })(),
      type: "text",
    },
    {
      heading: "Last BS date",
      content: (() => {
        const bsDate =
          cinVerificationData?.cin_details?.cin_number ===
          cinDetailsData?.cin_details?.cin_number
            ? cinVerificationData?.cin_details?.last_bs_date ||
              cinDetailsData?.cin_details?.last_bs_date
            : cinDetailsData?.cin_details?.last_bs_date;
        return bsDate ? formatDate(bsDate) : "N/A";
      })(),
      type: "text",
    },
  ];

  const handleClearParams = () => {
    setCinNo("");
    dispatch(resetSelectedCin());
    dispatch(resetGetCinData());
  };

  const isCinLengthValid = cinNo?.length === GlobalConfiguration?.cinLength;
  const isCinChanged = !!cinNo && cinNo !== prevCinNo;
  const hasCinLoading = !!getVerifyCinLoading;
  const hasCinError = !!cinDetailsError && !isCinChanged;

  const isCinButtonDisabled =
    !cinNo ||
    !isCinLengthValid ||
    hasCinLoading ||
    hasCinError ||
    cinStatus === "error" ||
    (!isCinChanged && cinStatus === "success") ||
    (cinDetailsData?.status &&
      cinDetailsData?.cin_details?.cin_number === cinNo);

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction({
      path: "/settings/CIN_verification",
      state: {
        cinNumber: cinNo,
      },
    });
  };
  useLayoutEffect(() => {
    if (tabIndex !== prevIndex) {
      const direction =
        tabIndex > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setTimeout(() => {
        setPrevIndex(tabIndex);
      }, IntervalConfiguration?.intervalSemiMid);
    }
  }, [tabIndex]);

  useEffect(() => {
    if (services && !services?.includes("VCIN")) {
      navigate("/feature_not_assigned");
    }

    if (selectedCinData) {
      setCinNo(selectedCinData);
      setPrevCinNo(selectedCinData);
      setCinStatus("success");
    } else if (cinNumber) {
      setCinNo(cinNumber);
      setPrevCinNo(cinNumber);
      setCinStatus("success");
    } else {
      setCinNo("");
      setPrevCinNo("");
      setCinStatus(null);
    }
    return () => {
      dispatch(resetSelectedCin());
      dispatch(resetGetCinData());
    };
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [cinNo, isCinButtonDisabled]);

  useEffect(() => {
    if (cinDetailsData?.cin_details?.company_address) {
      setLoading(false);
    }
  }, [cinDetailsData]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [cinNo]);

  useEffect(() => {
    if (services && !services?.includes("VCIN")) {
      navigate("/feature_not_assigned");
    }

    if (selectedCinData) {
      setCinNo(selectedCinData);
    } else if (cinNumber) {
      setCinNo(cinNumber);
    }
    return () => {
      dispatch(resetSelectedCin());
      dispatch(resetGetCinData());
    };
  }, []);

  useEffect(() => {
    if ((popup && cin_no) || cinNumber) {
      setCinNo(cin_no?.toUpperCase() || cinNumber?.toUpperCase());
      setPrevCinNo("");
      dispatch(resetGetCinData());
      dispatch(resetSelectedCin());
    }
  }, [popup, cin_no, cinNumber]);

  useEffect(() => {
    const isValidCin =
      cinNo &&
      cinNo.length === GlobalConfiguration.cinLength &&
      cinNo !== prevCinNo;

    // popup trigger
    if (popup && isValidCin) {
      handleCinClick(false);
      return;
    }

    // location one-time trigger
    if (
      initialCinFromLocation.current &&
      cinNo === initialCinFromLocation.current &&
      isValidCin
    ) {
      handleCinClick(false);
      initialCinFromLocation.current = "";
    }
  }, [popup, cinNo, prevCinNo]);

  return (
    <div
      className={`flex flex-col ${popup ? "h-height-full" : "h-screen"} bg-primary-bg overflow-y-auto overflow-x-hidden Qmd:overflow-x-hidden`}
    >
      <>{RestrictedActionPopup}</>
      {showDINPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="DIN Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/DIN_verification`, {
                state: { dinNumber: dinNo },
              })
            }
            closeiconhandleFunction={() => setDINShowPopup(false)}
          >
            <DINVerification
              din_no={dinNo}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      <div
        className={`Qsmd:hidden ${popup || showDINPopup ? "hidden" : "bg-primary-nav shadow-box-shadow-bottom fixed top-top-base left-left-base z-z-index-tooltip w-width-full block"}`}
      >
        <TopNavComponent
          isFormattingNotRequired={true}
          topNavHeader="CIN Verification"
        />
      </div>
      <div
        className={`hidden ${popup ? "hidden" : "Qmd:block mt-margin-xl Qmd:mt-margin-base Qmd:min-h-navbar-breadcrumb-height bg-primary-nav"}`}
      ></div>

      <div
        className={`p-mobile-padding-l Qmd:p-padding-md w-width-full bg-primary-nav opacity-base-opacity flex flex-col justify-center items-center z-z-index-header shadow-box-shadow-bottom ${popup ? "hidden" : "mt-margin-xl"} Qmd:mt-margin-base`}
        style={{
          paddingTop:
            activeButton === GlobalConfiguration?.lengthCheckOne
              ? "var(--padding-md)"
              : undefined,
          paddingBottom:
            activeButton === GlobalConfiguration?.lengthCheckOne
              ? "var(--padding-md)"
              : undefined,
        }}
      >
        <SearchBar
          searchText={cinNo}
          searchRef={inputRef}
          placeholder="Search CIN number"
          isSearchDisabled={popup ? true : false}
          onInput={handleCin}
          btnText="Fetch"
          onClick={() => {
            if (isCinButtonDisabled) return;
            if (
              (isCinLengthValid && getVerifyCinLoading === null) ||
              isCinChanged
            ) {
              handleCinClick(false);
              setActiveButton(GlobalConfiguration?.lengthCheckZero);
              setTabIndex(GlobalConfiguration?.lengthCheckZero);
              setPrevIndex(GlobalConfiguration?.lengthCheckZero);
            }
          }}
          isBtnDisable={isCinButtonDisabled}
          txtColor={
            !isCinButtonDisabled ? "var(--primary-bg)" : "var(--text-primary)"
          }
          btnColor={
            !isCinButtonDisabled
              ? "var(--text-primary)"
              : "var(--text-disabled)"
          }
          inActiveVariantNeeded={true}
        />
      </div>
      {getVerifyCinLoading ? (
        <div className="w-full  flex items-center justify-center">
          <div className="owner_loader-container">
            <Loader />
          </div>
        </div>
      ) : !getVerifyCinLoading && cinDetailsData?.status ? (
        <>
          <div className="w-auto bg-primary-nav">
            <div
              className="mx-auto px-mobile-padding-l Qmd:px-padding-md Qlg:px-padding-base sm:mt-margin-base"
              style={{
                maxWidth: "var(--max-content-width)",
              }}
            >
              <div className="grid grid-cols-1 md:grid-cols-3 border-b border-primary-bg ">
                <div className="pr-padding-base md:pr-padding-md py-mobile-padding-l Qmd:py-padding-md">
                  <TitleSubtitlePair
                    title={(() => {
                      const companyName = accountNameStandardised(
                        cinVerificationData?.cin_details?.cin_number ===
                          cinDetailsData?.cin_details?.cin_number
                          ? cinVerificationData?.cin_details?.company_name ||
                              cinDetailsData?.cin_details?.company_name
                          : cinDetailsData?.cin_details?.company_name,
                      );

                      return companyName || "N/A";
                    })()}
                    subtitle="Account name"
                    titleColor="text-primary"
                    variant="md"
                  />
                </div>
                <div className="border-t md:border-t-0 md:border-l border-primary-bg px-padding-base md:px-padding-md my-margin-base md:my-margin-md md:py-padding-base py-mobile-padding-l">
                  <div className="flex flex-col">
                    <TitleSubtitlePair
                      title={(() => {
                        const effectiveCin =
                          cinVerificationData?.cin_details?.cin_number ===
                          cinDetailsData?.cin_details?.cin_number
                            ? cinVerificationData?.cin_details?.cin_number ||
                              cinDetailsData?.cin_details?.cin_number
                            : cinDetailsData?.cin_details?.cin_number;

                        return effectiveCin || "N/A";
                      })()}
                      subtitle="CIN number"
                      titleColor="text-primary"
                      variant="md"
                    />
                  </div>
                </div>

                <div className="hidden md:flex justify-end flex-col md:flex-row items-center flex-grow">
                  <TopNavSmallButton
                    btnText={
                      <>
                        Refresh <br /> details
                      </>
                    }
                    btnType="button"
                    handleFunction={() => {
                      if (popup) {
                        actionRestricted();
                        return;
                      }
                      handleCinClick(true);
                    }}
                    enabledTextColor="var(--text-primary)"
                    enabledBgColor="var(--primary-nav-act)"
                    disabledBgColor="var(--primary-nav-act)"
                    icon={ICONS?.REFRESH_BALANCE}
                    hoverOption="white"
                    isDisabled={popup || cinVerificationLoading}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 border-b border-primary-bg  items-center py-padding-base md:py-padding-md">
                <div className="border-b md:border-b-0 md:border-r border-primary-bg md:py-padding-base py-mobile-padding-l">
                  <TitleSubtitlePair
                    title={(() => {
                      const incorpDate =
                        cinVerificationData?.cin_details?.cin_number ===
                        cinDetailsData?.cin_details?.cin_number
                          ? cinVerificationData?.cin_details
                              ?.incorporation_date ||
                            cinDetailsData?.cin_details?.incorporation_date
                          : cinDetailsData?.cin_details?.incorporation_date;
                      return incorpDate ? formatDate(incorpDate) : "N/A";
                    })()}
                    subtitle="Estd. on"
                    titleColor="text-primary"
                    variant="md"
                  />
                </div>
                <div className="px-padding-base md:px-padding-md md:py-padding-base py-mobile-padding-l">
                  <TitleSubtitlePair
                    title={(() => {
                      const listedStatus =
                        cinVerificationData?.cin_details?.cin_number ===
                        cinDetailsData?.cin_details?.cin_number
                          ? cinVerificationData?.cin_details?.listed_status ||
                            cinDetailsData?.cin_details?.listed_status
                          : cinDetailsData?.cin_details?.listed_status;
                      return listedStatus || "N/A";
                    })()}
                    subtitle="Listed status"
                    titleColor="text-primary"
                    variant="md"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 items-center py-padding-base md:py-padding-md">
                <div className="border-b md:border-b-0 md:border-r border-primary-bg md:py-padding-base py-mobile-padding-l">
                  <TitleSubtitlePair
                    title={(() => {
                      const effectiveStatus =
                        cinVerificationData?.cin_details?.cin_number ===
                        cinDetailsData?.cin_details?.cin_number
                          ? cinVerificationData?.cin_details?.company_status ||
                            cinDetailsData?.cin_details?.company_status
                          : cinDetailsData?.cin_details?.company_status;
                      return effectiveStatus || "N/A";
                    })()}
                    subtitle="Company status"
                    titleColor={
                      cinVerificationData?.cin_details?.company_status ||
                      cinDetailsData?.cin_details?.company_status === "Active"
                        ? "settled"
                        : "negative-act"
                    }
                    variant="md"
                    isBold={true}
                  />
                </div>

                <div className="px-padding-base md:py-padding-base py-mobile-padding-l md:px-padding-md">
                  <TitleSubtitlePair
                    title={(() => {
                      const companyClass =
                        cinVerificationData?.cin_details?.cin_number ===
                        cinDetailsData?.cin_details?.cin_number
                          ? cinVerificationData?.cin_details?.company_class ||
                            cinDetailsData?.cin_details?.company_class
                          : cinDetailsData?.cin_details?.company_class;

                      if (!companyClass) return "N/A";

                      return companyClass === "PUBC" ? "Public" : "Private";
                    })()}
                    subtitle="Class of company"
                    titleColor="text-primary"
                    variant="md"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="bg-primary-nav block md:hidden mt-margin-md">
            <div className="bg-primary-card pl-mobile-padding-l py-padding-sm">
              <p className="text-font-sm text-text-primary font-semibold flex items-center">
                Quick Actions
              </p>
            </div>
            <div className="flex md:hidden justify-end flex-col md:flex-row items-center h-[var(--topnav-small-btn-width)]">
              <TopNavSmallButton
                btnText="Refresh details"
                btnType="button"
                handleFunction={() => {
                  if (popup) {
                    actionRestricted();
                    return;
                  }
                  handleCinClick(true);
                }}
                enabledTextColor="var(--text-primary)"
                enabledBgColor="var(--primary-nav-act)"
                disabledBgColor="var(--primary-nav-act)"
                icon={ICONS?.REFRESH_BALANCE}
                hoverOption="white"
                fullWidthRequired
                isDisabled={popup || cinVerificationLoading}
              />
            </div>
          </div>

          <div className="w-width-full py-mobile-padding-xl Qmd:py-padding-md bg-primary-bg flex justify-center">
            <div className="w-width-full max-w-tab-width-normal">
              <div className="flex pb-padding-md ml-margin-base overflow-x-auto pl-mobile-padding-l Qmd:pl-padding-md Qlg:pl-padding-base">
                <SwitcherTabs
                  tabs={tabOptions}
                  initialActiveTab={
                    activeButton === GlobalConfiguration?.lengthCheckZero
                      ? "details"
                      : activeButton === GlobalConfiguration?.lengthCheckOne
                        ? "directors"
                        : "address"
                  }
                  type="single"
                  setIndex={setTabIndex}
                />
              </div>

              <div className="relative">
                {tabIndex === GlobalConfiguration?.lengthCheckZero && (
                  <div className={tabIndex === prevIndex ? "" : animationClass}>
                    <div className="flex gap-gap-md flex-col sm:flex-col md:flex-row lg:flex-row items-center md:items-start lg:items-start px-mobile-padding-l Qmd:px-padding-md Qlg:px-padding-base">
                      <CommonDetailCard
                        cardTitle="Contact Details"
                        numCols={GlobalConfiguration?.lengthCheckOne}
                        variant="fourth"
                        entries={contactDetailsEntries}
                      />

                      <CommonDetailCard
                        cardTitle="Capital Details"
                        numCols={GlobalConfiguration?.lengthCheckOne}
                        variant="fourth"
                        entries={capitalDetailsEntries}
                      />

                      <CommonDetailCard
                        cardTitle="Annual Compliance Status"
                        numCols={GlobalConfiguration?.lengthCheckOne}
                        variant="fourth"
                        entries={complianceDetailsEntries}
                      />
                    </div>
                  </div>
                )}
                {tabIndex === GlobalConfiguration?.lengthCheckOne && (
                  <div className={animationClass}>
                    <div className="grid grid-cols-1 gap-gap-md Qsm:grid-cols-2 sm:grid-cols-3 Qsmd:grid-cols-4 px-mobile-padding-l Qmd:px-padding-md Qlg:pl-padding-base">
                      {(() => {
                        const directors =
                          cinVerificationData?.cin_details?.cin_number ===
                          cinDetailsData?.cin_details?.cin_number
                            ? cinVerificationData?.cin_details?.directors ||
                              cinDetailsData?.cin_details?.directors
                            : cinDetailsData?.cin_details?.directors;
                        return directors?.map((data, i) => (
                          <div
                            key={data?.din_number || i}
                            className="cursor-pointer"
                          >
                            <CommonDetailCard
                              cardTitle={accountNameStandardised(
                                data?.director_name,
                              )}
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="fourth"
                              entries={[
                                {
                                  heading: "DIN number",
                                  content: data?.din_number,
                                  type: "text",
                                  isDisabled: popup ? true : false,
                                },
                              ]}
                              isDisabled={popup}
                              onClick={() => {
                                if (popup) {
                                  actionRestricted();
                                  return;
                                }
                                if (ensureAny(["VDIN"]).status) {
                                  setDINShowPopup(true);
                                  setDinNo(data?.din_number);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VDIN",
                                    },
                                  });
                                }
                              }}
                            />
                          </div>
                        ));
                      })()}
                    </div>
                  </div>
                )}
                {tabIndex === GlobalConfiguration?.lengthCheckTwo && (
                  <div className={animationClass}>
                    <CommonContainerCard header={TEXT?.CORPORATE_ADDRESS}>
                      <div className="flex flex-col gap-gap-md md:flex-row Qmd:flex-row items-start justify-between">
                        <div className="flex flex-col gap-y-gap-xs">
                          {(() => {
                            const companyAddress =
                              cinVerificationData?.cin_details?.cin_number ===
                              cinDetailsData?.cin_details?.cin_number
                                ? cinVerificationData?.cin_details
                                    ?.company_address ||
                                  cinDetailsData?.cin_details?.company_address
                                : cinDetailsData?.cin_details?.company_address;
                            return (
                              <p className="text-text-primary text-font-sm font-normal">
                                {companyAddress || "N/A"}
                              </p>
                            );
                          })()}
                        </div>

                        {!loading ? (
                          <div className="flex justify-center Qmd:justify-center md:justify-end Qmd:max-w-max-map-leaflet-width w-width-full Qmd:flex-shrink-0 flex-shrink">
                            <GeoMapLeaflet
                              address={(() => {
                                const address =
                                  cinVerificationData?.cin_details
                                    ?.cin_number ===
                                  cinDetailsData?.cin_details?.cin_number
                                    ? cinVerificationData?.cin_details
                                        ?.company_address ||
                                      cinDetailsData?.cin_details
                                        ?.company_address
                                    : cinDetailsData?.cin_details
                                        ?.company_address;

                                return address;
                              })()}
                              owner="cin_details"
                            />
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </CommonContainerCard>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      ) : !getVerifyCinLoading && cinDetailsError === true ? (
        <div className="flex flex-col justify-center gap-gap-sm items-center mx-auto my-auto">
          <img
            src={ICONS?.NO_DATA_FOUND}
            alt="notfound"
            className="px-padding-md w-graphic-width-md h-graphic-rectangle-height-md"
          />
          <p className="text-font-sm text-text-primary text-center font-sans font-normal py-padding-sm">
            No data found.
          </p>
          <PrimaryButton
            btnText="Clear parameters"
            enabledBgColor="var(--primary-act)"
            enabledTextColor="var(--text-primary)"
            handleFunction={handleClearParams}
            hoverOption="white"
            isDisabled={false}
          />
        </div>
      ) : (
        <div className="flex flex-col justify-center gap-gap-sm items-center mx-auto my-auto">
          <img
            src={ICONS?.IFSC_VERIFICATION_GRAPHICS}
            alt="bgDefault"
            className="px-padding-md h-graphic-square-height-md w-graphic-width-md"
          />
          <p className="text-text-primary text-font-sm text-center font-sans">
            Enter CIN number in the search bar<br></br> to fetch the verified
            corporate profile details.
          </p>
        </div>
      )}
    </div>
  );
};

export default CINVerification;
